const swiper35 = new Swiper('.videos-slider-wrapper', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 3,
     navigation: {
            nextEl: ".swiper-button-nextsss",
            prevEl: ".swiper-button-prevsss",
        },
    breakpoints: {
        2560:{
            slidesPerView: 3,
            spaceBetween: 10,
        },
        1024:{
            slidesPerView: 3,
            spaceBetween: 10,
        },
        1440:{
            slidesPerView: 3,
            spaceBetween: 10,
        },
        767:{
            slidesPerView: 1,
            spaceBetween: 20,
        },
        426:{
            slidesPerView: 1.1,
            spaceBetween: 20,
        },
        375:{
          slidesPerView: 1.1,
          spaceBetween: 20,
        },
      320:{
          slidesPerView: 1.1,
          spaceBetween: 15,
        }
    }
})